import request from '@/utils/request'

// 查询社区小组帖子关联话题列表
export function listCommunityGroupPostTopic(query) {
  return request({
    url: '/biz/admin/community/community/group/post/topic/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区小组帖子关联话题分页
export function pageCommunityGroupPostTopic(query) {
  return request({
    url: '/biz/admin/community/community/group/post/topic/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区小组帖子关联话题详细
export function getCommunityGroupPostTopic(data) {
  return request({
    url: '/biz/admin/community/community/group/post/topic/detail',
    method: 'get',
    params: data
  })
}

// 新增社区小组帖子关联话题
export function addCommunityGroupPostTopic(data) {
  return request({
    url: '/biz/admin/community/community/group/post/topic/add',
    method: 'post',
    data: data
  })
}

// 修改社区小组帖子关联话题
export function updateCommunityGroupPostTopic(data) {
  return request({
    url: '/biz/admin/community/community/group/post/topic/edit',
    method: 'post',
    data: data
  })
}

// 删除社区小组帖子关联话题
export function delCommunityGroupPostTopic(data) {
  return request({
    url: '/biz/admin/community/community/group/post/topic/delete',
    method: 'post',
    data: data
  })
}
